import { Component, OnInit, AfterViewInit } from '@angular/core';
import $ from 'jquery';


@Component({
  selector: 'app-nivo-slider',
  standalone: true,
  imports: [],
  templateUrl: './nivo-slider.component.html',
  styleUrl: './nivo-slider.component.scss'
})
export class NivoSliderComponent {
  constructor() { }

  ngOnInit(): void {
    // Any necessary initialization logic can go here
  }

  ngAfterViewInit(): void {
    // Check if jQuery is available
    if (typeof jQuery !== 'undefined') {
      console.log('jQuery is available');
      // Initialize Nivo Slider if jQuery is available
      $('#ais_148').nivoSlider();
    } else {
      console.error('jQuery is not available');
    }
  }
}
